module.exports = __webpack_public_path__ + "img/pangsit.bd15ffa2.jpg";